import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { RootState } from '@/redux/store';
// import './HomeFaq.scss';

type ContentItem = {
	title: string;
	text: string;
};

type FaqItemProps = {
	expandedPanel: string;
	handleChange: (panel: string) => void;
	content: ContentItem;
};

const FaqItem: FC<FaqItemProps> = ({
	expandedPanel,
	handleChange,
	content,
}) => {
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	return (
		<div className={`home-faq__item theme-${isDarkTheme ? 'dark' : 'light'}`}>
			<Accordion
				expanded={expandedPanel === content.title}
				onChange={() => handleChange(content.title)}
				elevation={0}
			>
				<AccordionSummary
					aria-controls="panel1a-content"
					className={`home-faq__item-header ${
						expandedPanel === content.title ? 'opened' : ''
					}`}
					expandIcon={
						expandedPanel === content.title ? (
							<RemoveIcon
								sx={{ fontSize: '1.2rem', color: isDarkTheme ? '#fff' : '#222' }}
							/>
						) : (
							<AddIcon
								sx={{ fontSize: '1.2rem', color: isDarkTheme ? '#fff' : '#222' }}
							/>
						)
					}
				>
					<Typography>{content.title}</Typography>
				</AccordionSummary>
				<AccordionDetails className="home-faq__item-text-wrapper">
					<div className="home-faq__item-text-title">
						<Typography sx={{ fontWeight: '600' }}>Answer</Typography>
					</div>
					<div className="home-faq__item-text text-block">
						<Typography>{content.text}</Typography>
					</div>
				</AccordionDetails>
			</Accordion>
		</div>
	);
};

const content = [
	{
		title: 'How does it work?',
		text: `After subscribing to our service, your account will have a unique code that you can use for each request to our APIs. 
			We provide detailed guides on how to use it in every application you plan to build.`,
	},
	{
		title: 'What is included in each task?',
		text: `We provide all the resources you need to successfully complete every application development project. 
		Each application comes with UI/UX designs in Figma and Pixso. Projects are divided into tasks, with each task including clear product requirements and guidance on which APIs to use. 
		Once you complete the development, you can submit your code as a GitHub repository link, and we will showcase it to our community.`,
	},
	{
		title: 'Which technology do I need to use?',
		text: `Our product requirements, UI/UX designs, and backend APIs are frontend-agnostic, allowing you to use any framework or tools to meet all requirements and integrations. 
			This flexibility enables you to learn and work with any frontend framework without limitations.`,
	},
	{
		title: 'What if I have questions or need help during the course?',
		text: `You can contact our support team via email or contact form. Additionally, many courses include dedicated discussion boards where students can ask questions. 
		For more in-depth guidance, you can book one of our mentorship services for a comprehensive consultation with one of our experienced mentors.`,
	},
	{
		title: 'Is there a refund policy?',
		text:
			'Yes, we offer a 30-day money-back guarantee if you are not satisfied with the course.',
	},
];

const FaqList = () => {
	const [expandedPanel, setExpandedPanel] = useState<string>('');

	const handleChange = (panel: string) => {
		setExpandedPanel(expandedPanel === panel ? '' : panel);
	};
	return (
		<div className="home-faq__items-wrapper">
			{content.map((item) => (
				<FaqItem
					expandedPanel={expandedPanel}
					handleChange={handleChange}
					content={item}
				/>
			))}
		</div>
	);
};

export default FaqList;
